import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/* ===== MOCK opcional ===== */
const delay = (ms = 250) => new Promise((r) => setTimeout(r, ms));
const isMock = typeof process !== "undefined" &&
  process.env?.REACT_APP_MOCK_PIPELINE === "1";

let MOCK_DB = [
  { id: 1, nome: "Prospecção", ordem: 1, probabilidade: 5,  cor: "#607D8B", tipo: "normal", sla_dias: 7,  status: 1 },
  { id: 2, nome: "Qualificação", ordem: 2, probabilidade: 15, cor: "#03A9F4", tipo: "normal", sla_dias: 7,  status: 1 },
  { id: 3, nome: "Proposta",    ordem: 3, probabilidade: 40, cor: "#FFC107", tipo: "normal", sla_dias: 10, status: 1 },
  { id: 4, nome: "Negociação",  ordem: 4, probabilidade: 65, cor: "#FF9800", tipo: "normal", sla_dias: 10, status: 1 },
  { id: 5, nome: "Ganho",       ordem: 5, probabilidade: 100,cor: "#4CAF50", tipo: "ganho",  sla_dias: null, status: 1 },
  { id: 6, nome: "Perdido",     ordem: 6, probabilidade: 0,  cor: "#F44336", tipo: "perdido",sla_dias: null, status: 1 },
];

const mockFetch = async (url, method = "GET", body) => {
  await delay();
  const q = Object.fromEntries(new URLSearchParams(url.split("?")[1] || ""));
  if (method === "GET") {
    const page  = Math.max(1, Number(q.page)  || 1);
    const limit = Math.max(1, Number(q.limit) || 50);
    const search = (q.search || "").toLowerCase();
    let list = MOCK_DB.slice();
    if (search) {
      list = list.filter(
        s =>
          s.nome.toLowerCase().includes(search) ||
          String(s.probabilidade).includes(search)
      );
    }
    list.sort((a,b)=>(a.ordem||0)-(b.ordem||0));
    const start = (page-1)*limit;
    const slice = list.slice(start, start+limit);
    return { data: slice, pagination: { total: list.length, page, limit } };
  }
  if (method === "POST") {
    const nextId = MOCK_DB.length ? Math.max(...MOCK_DB.map(s=>s.id))+1 : 1;
    const created = { id: nextId, ...body };
    MOCK_DB.push(created);
    return { data: created };
  }
  if (method === "PUT") {
    const id = Number(url.split("/")[2]);
    const i = MOCK_DB.findIndex(s=>s.id===id);
    if (i>=0) MOCK_DB[i] = { ...MOCK_DB[i], ...body };
    return { data: MOCK_DB[i] };
  }
  if (method === "DELETE") {
    const id = Number(url.split("/")[2]);
    MOCK_DB = MOCK_DB.filter(s=>s.id!==id);
    return { data: { success: true } };
  }
  throw new Error("mock: método não suportado");
};

const doFetch = (url, method = "GET", body) =>
  isMock ? mockFetch(url, method, body) : fetchData(url, method, body);
/* ===== /MOCK ===== */

export const usePipelineStages = (page = 1, limit = 50, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["pipeline_stages", page, limit, search],
    () =>
      doFetch(
        `/pipeline-stages?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
      ),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        stages: response?.data || [],
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (stage) => {
      const method = stage.id ? "PUT" : "POST";
      const endpoint = stage.id
        ? `/pipeline-stages/${stage.id}`
        : `/pipeline-stages`;
      return doFetch(endpoint, method, stage);
    },
    { onSuccess: () => queryClient.invalidateQueries("pipeline_stages") }
  );

  const deleteMutation = useMutation(
    (id) => doFetch(`/pipeline-stages/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("pipeline_stages") }
  );

  return { ...query, updateMutation, deleteMutation };
};
